import clsx from 'clsx'
import { motion } from 'motion/react'
import NextLink from 'next/link'

const Link = motion(NextLink as any)

const defaultTextProps = {
  heading: 'Ready to make your first map?',
  cta: 'Make your free map'
}

export function Cta(props) {
  const { textProps = defaultTextProps } = props
  return (
    <div
      className={clsx(
        'bg-black flex justify-center items-center pt-[6%] pb-0 overflow-hidden bg-none h-[600px] relative w-full mx-auto',
        'max-[768px]:h-[190vw] max-[768px]:mb-0 max-[768px]:pt-[114px]'
      )}
    >
      <Link
        className={clsx(
          'bg-brand-02 px-[32px] py-[24px] text-[24px] font-[700] leading-[17px] decoration-[none] relative top-auto text-white rounded-lg text-center',
          'max-[768px]:top-[25vw]'
        )}
        whileHover={{
          scale: 1.1,
          transition: { duration: 0.3, ease: 'easeInOut' }
        }}
        href='/sign-up'
      >
        {textProps?.cta}
      </Link>
      <div className='absolute top-[96px] my-0 text-center max-w-[1110px] mx-auto mt-[40px] mb-[40px]'>
        <h2 className='text-white leading-[-1px] text-[48px] text-center font-[700] max-[768px]:text-[7.8vw] px-[16px]'>
          {textProps?.heading}
        </h2>
      </div>
    </div>
  )
}
